import React from 'react';

interface OptionButtonProps {
    value: string;
    keyProp: string | null;
    index: number;
    isSelected: boolean;
    renderKey: number;
    isDisabled?: boolean;
    onClick: (value: string, key?: string) => void;
}

const OptionButton: React.FC<OptionButtonProps> = ({
    value,
    keyProp,
    index,
    isSelected,
    renderKey,
    isDisabled = false,
    onClick
}) => {
    const handleClick = () => {
        if (!isDisabled) {
            onClick(value, keyProp || undefined);
        }
    };

    const handleKeyActivate = (e: React.KeyboardEvent) => {
        if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onClick(value, keyProp || undefined);
        }
    };

    return (
        <div
            className={`chat-option ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
            key={keyProp ? `${keyProp}-${index}-${renderKey}` : `${value}-${index}-${renderKey}`}
            onClick={handleClick}
            role="button"
            tabIndex={isDisabled ? -1 : 0}
            onKeyDown={handleKeyActivate}
            title={isDisabled ? 'This option has already been selected' : `Click to select ${value}`}
            aria-disabled={isDisabled}
        >
            <p className="chat-option-des">{value}</p>
        </div>
    );
};

export default OptionButton;



